var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBcPnpIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_315_1424)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 32,
    r: 21,
    fill: "#FFC13F"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.2277 25.625C32.3937 26.039 31.6958 26.6815 31.2129 27.4734H32.6262C32.7981 26.7595 33.0174 26.1332 33.2277 25.625Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4093 28.625H30.6959C30.5653 29.0666 30.4922 29.5327 30.4922 30.0163C30.4922 30.4998 30.5653 30.966 30.6959 31.4075H32.4093C32.2691 30.4242 32.2931 29.4835 32.4093 28.625Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2125 32.5703C31.7361 33.4282 32.5114 34.1146 33.4388 34.5207C33.0853 33.8668 32.8277 33.2135 32.6498 32.5703H31.2125Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0781 25.1628C35.8534 25.131 35.6264 25.1094 35.3933 25.1094C35.1603 25.1094 34.9332 25.1316 34.7085 25.1628C34.4749 25.5875 34.0759 26.4053 33.7871 27.4696H36.9995C36.7108 26.4053 36.3118 25.5875 36.0781 25.1628Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5749 27.4734C39.092 26.6821 38.394 26.039 37.5601 25.625C37.7703 26.1332 37.9896 26.7589 38.1616 27.4734H39.5749Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5433 28.625C33.4163 29.4727 33.3917 30.417 33.5601 31.4075H37.2266C37.395 30.417 37.3704 29.4727 37.2434 28.625H33.5433Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0437 34.9125C35.1599 34.9209 35.2756 34.9305 35.3936 34.9305C35.5116 34.9305 35.6272 34.9209 35.7429 34.9125C36.3018 34.1302 36.6877 33.3424 36.9393 32.5703H33.8467C34.0983 33.3424 34.4841 34.1302 35.0431 34.9125H35.0437Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3765 31.4075H40.0905C40.2211 30.966 40.2942 30.4998 40.2942 30.0163C40.2942 29.5327 40.2211 29.0666 40.0905 28.625H38.3771C38.4933 29.4835 38.5167 30.4242 38.3765 31.4075Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2674 19.6875H26.7326C25.7776 19.6875 25 20.4656 25 21.4225V46.2621C25 47.2184 25.777 47.9971 26.7326 47.9971H44.2674C45.2224 47.9971 46 47.219 46 46.2621V21.4225C46 20.4662 45.223 19.6875 44.2674 19.6875ZM41.4498 42.4818C41.4498 43.1196 40.9315 43.6385 40.2947 43.6385H30.1254C29.4885 43.6385 28.9703 43.1196 28.9703 42.4818V41.2675C28.9703 40.6298 29.4885 40.1108 30.1254 40.1108H40.2947C40.9315 40.1108 41.4498 40.6298 41.4498 41.2675V42.4818ZM35.394 36.084C32.0545 36.084 29.3382 33.3633 29.3382 30.0192C29.3382 26.6751 32.0545 23.9549 35.394 23.9549C38.7334 23.9549 41.4498 26.6757 41.4498 30.0192C41.4498 33.3627 38.7334 36.084 35.394 36.084Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3472 34.5213C38.2752 34.1158 39.051 33.4288 39.5741 32.5703H38.1362C37.9589 33.2135 37.7006 33.8668 37.3472 34.5213Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2328 17.5636C43.2328 17.0843 43.0177 16.6385 42.6439 16.3403C42.2694 16.0422 41.7895 15.933 41.3216 16.0404L30.5269 18.5301H43.2322V17.5636H43.2328Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_315_1424",
    x: 0,
    y: 0,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.291667 0 0 0 0 0.291667 0 0 0 0 0.291667 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_315_1424"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_315_1424",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBcPnpIcon);
export default __webpack_public_path__ + "static/media/bc-pnp-icon.548caf51ba8790967110c5f3eb27d2c5.svg";
export { ForwardRef as ReactComponent };